let generation = 0
let active = true
let refreshPromise = null
let invalidationError = null

const createInvalidationError = () => {
  const error = new Error('The authentication session is no longer active.')
  error.code = 'AUTH_SESSION_INVALIDATED'
  return error
}

export const activateAuthSession = () => {
  generation += 1
  active = true
  invalidationError = null
}

export const invalidateAuthSession = () => {
  if (!active) return invalidationError

  generation += 1
  active = false
  invalidationError = createInvalidationError()
  return invalidationError
}

export const runSingleFlightRefresh = (refreshOperation, applyResult) => {
  if (refreshPromise) return refreshPromise

  const refreshGeneration = generation
  refreshPromise = Promise.resolve()
    .then(refreshOperation)
    .then(result => {
      if (!active || generation !== refreshGeneration) {
        throw invalidationError || createInvalidationError()
      }
      applyResult(result)
      return result
    })

  refreshPromise = refreshPromise.then(
    result => {
      refreshPromise = null
      return result
    },
    error => {
      refreshPromise = null
      throw error
    }
  )

  return refreshPromise
}

export const isAuthSessionActive = () => active



// WEBPACK FOOTER //
// ./src/auth/authSession.js